module.exports = __webpack_public_path__ + "static/sjova-4-901dd0a4468c3185d663caa158f640aa.jpg";